/* Product card: swipe dots + colour switch. Cart drawer: suggestion quick-add + is-empty sync. */
(function () {
  function syncDots(m) {
    var d = m.parentNode.querySelector('.ly-card__dots');
    if (!d || !m.clientWidth) return;
    var i = Math.round(Math.abs(m.scrollLeft) / m.clientWidth);
    for (var k = 0; k < d.children.length; k++) d.children[k].classList.toggle('is-on', k === i);
  }
  document.addEventListener('scroll', function (e) {
    var m = e.target;
    if (m.classList && m.classList.contains('ly-card__media')) syncDots(m);
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-ly-sw]');
    if (!b) return;
    e.preventDefault();
    var c = b.closest('.ly-card'), d = b.dataset;
    c.querySelectorAll('a[href]').forEach(function (a) { a.href = d.url; });
    var imgs = c.querySelectorAll('.ly-card__img');
    if (imgs[0] && d.img) { imgs[0].removeAttribute('srcset'); imgs[0].src = d.img; imgs[0].alt = d.title; }
    if (imgs[1]) {
      if (d.img2) { imgs[1].removeAttribute('srcset'); imgs[1].src = d.img2; imgs[1].hidden = false; }
      else imgs[1].hidden = true;
    }
    var dots = c.querySelector('.ly-card__dots');
    if (dots) dots.hidden = !d.img2;
    var n = c.querySelector('.ly-card__name a'); if (n) n.textContent = d.title;
    var sub = c.querySelector('.ly-card__sub');
    if (sub) {
      sub.textContent = d.sub || '';
      if (d.finish) { var dot = document.createElement('span'); dot.className = 'ly-dot ly-dot--' + d.finish; dot.setAttribute('aria-hidden', 'true'); sub.prepend(dot); }
    }
    var p = c.querySelector('.ly-card__price'); if (p) { p.textContent = ''; var s = document.createElement('span'); s.textContent = d.price; p.appendChild(s); }
    c.querySelectorAll('[data-ly-sw]').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    var m = c.querySelector('.ly-card__media'); if (m) { m.scrollLeft = 0; syncDots(m); }
  });

  /* Cart drawer suggestions: size pickers live inside <cart-drawer-items>, whose Dawn handler treats any
     'change' as a quantity edit. Keep those events to ourselves. */
  document.addEventListener('change', function (e) {
    var card = e.target.closest && e.target.closest('.lyc-xs__card');
    if (!card) return;
    card.classList.remove('is-need');
    e.stopPropagation();
  }, true);

  /* Cart drawer suggestions: one-tap add (asks for the size first when the piece has sizes) */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-lyc-add]');
    if (!b) return;
    e.preventDefault();
    var card = b.closest('.lyc-xs__card');
    var sel = card && card.querySelector('select');
    var id = sel ? sel.value : b.dataset.variant;
    if (!id) {
      card.classList.add('is-need');
      if (sel) sel.focus();
      return;
    }
    b.disabled = true;
    var items = [{ id: Number(id), quantity: 1 }];
    var done = function () { b.disabled = false; };
    if (window.LY && LY.addItems) LY.addItems(items).catch(function () {}).finally(done);
    else fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function () { location.reload(); }).finally(done);
  });

  /* Cart drawer: keep the drawer's is-empty flag in sync after it re-renders (Dawn only sets it on full page load) */
  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    var sync = function () { drawer.classList.toggle('is-empty', !drawer.querySelector('.cart-item')); };
    new MutationObserver(sync).observe(drawer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();
})();
